<mat-toolbar class="notifications-toolbar">
    <div class="notifications-toolbar__container">
        <div class="notifications-toolbar__header">Notifications</div>
        <button (click)="closeDialog()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</mat-toolbar>

<ng-container
    *ngIf="{
        notifications: notifications$ | async,
        unreadNotifications: unreadNotifications$ | async,
        unreadNotificationCount: unreadNotificationCount$ | async
    } as stream">
    <ng-container
        *ngIf="
            stream.notifications != null &&
                stream.unreadNotifications != null &&
                stream.unreadNotifications != null;
            else loader
        ">
        <mat-tab-group class="notifications-tab-group">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="notifications-tabgroup__label">UNREAD</span>
                    <span class="notifications-tabgroup__label-count">{{
                        stream.unreadNotificationCount
                    }}</span>
                </ng-template>
                <ng-template matTabContent>
                    <app-notifications-list-view
                        #notificationListView
                        [notifications]="stream.unreadNotifications"
                        (notificationViewEvent)="onNotificationView($event)"
                        (notificationsScrollDownEvent)="
                            onNotificationsScrollDown()
                        "
                        (toggleReadNotificationEvent)="
                            toggleReadNotification($event)
                        "></app-notifications-list-view>
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="notifications-tabgroup__label">ALL</span>
                </ng-template>
                <ng-template matTabContent>
                    <app-notifications-list-view
                        #notificationListView
                        [notifications]="stream.notifications"
                        (notificationViewEvent)="onNotificationView($event)"
                        (notificationsScrollDownEvent)="
                            onNotificationsScrollDown()
                        "
                        (toggleReadNotificationEvent)="
                            toggleReadNotification($event)
                        ">
                    </app-notifications-list-view>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <button
            (click)="readAllNotifications()"
            class="all_read"
            mat-flat-button>
            Mark All As Read
        </button>
    </ng-container>
</ng-container>

<ng-template #loader>
    <div class="notification-spinner">
        <mat-spinner class="spinner"></mat-spinner>
    </div>
</ng-template>
